import { axiosClient } from '../../axiosClient';
import type { AnalyticsFilterOptions, FormResponses } from '../types';

export const getFormResponses = ({
  agentId,
  deployId,
  formId,
  startDate,
  endDate,
}: AnalyticsFilterOptions & { formId: number }) =>
  axiosClient.get<FormResponses[]>(
    `analytics/forms/responses/${agentId}/${deployId}/${formId}`,
    {
      params: {
        ...(startDate && { start_time: startDate }),
        ...(endDate && { end_time: endDate }),
      },
    }
  );
